module.exports = __webpack_public_path__ + "static/media/desktop-components-buttons-icon-buttons-64-more-red.792ff364.svg";